import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import React from "react";
import { Button } from "semantic-ui-react";
import { formatLongDate } from "utilities";
import { findEnumObject } from "utilities/enumutils";
import { Modal } from "../../components";
import Tag from "../../components/Tag/Tag";

interface Props {
  client: server.dto.Client
  activeSubscription: server.dto.Subscription
  nextSubscription: server.dto.NextSubscription
  isOpen: boolean
  onClose: () => void
}

interface TypeOptionProps {
  type: server.dto.SubscriptionTypes
  selectedType: server.dto.SubscriptionType
  selectedBillingCycle: server.dto.BillingCycle
  hasBillingCycle: boolean
  onBillingCycleChanged: (cycle: server.dto.BillingCycle) => void
}

const TypeOption = (props: TypeOptionProps) => {
  const isActive = props.selectedType.value === props.type;
  const displayBillingCycle = props.hasBillingCycle && isActive;

  if (displayBillingCycle) {
    return <div className="margin-left-large">
      <RadioGroup
        orientation="horizontal"
        options={serverReference.billingCycles.map(cycle => ({ label: cycle.text, value: cycle.value }))}
        value={props.selectedBillingCycle != null ? props.selectedBillingCycle.value : undefined}
        onChange={(value) => {
          const cycle = findEnumObject(value, serverReference.billingCycles);
          props.onBillingCycleChanged(cycle);
        }}
      />
    </div>;
  }

  return null;
};

const ChangeNextSubscriptionModal = (props: Props) => {
  const [selectedType, setSelectedType] = React.useState<server.dto.SubscriptionType>(findEnumObject(props.nextSubscription.type, serverReference.subscriptionTypes));
  const [selectedCycle, setSelectedCycle] = React.useState<server.dto.BillingCycle>(findEnumObject(props.nextSubscription.billingCycle, serverReference.billingCycles));
  const [isSaving, setIsSaving] = React.useState<boolean>(false);

  const subscriptionTypeValues: server.dto.SubscriptionTypes[] = ["free", "paid", "readOnly", "cancelledByClient", "cancelledBySystemOne"];

  const hasBillingCycles = (type: server.dto.SubscriptionTypes) => type === "paid" || type === "readOnly";

  const onSubscriptionTypeChanged = (type: server.dto.SubscriptionTypes) => {
    const subscriptionType = findEnumObject(type, serverReference.subscriptionTypes);
    setSelectedType(subscriptionType);

    if (hasBillingCycles(subscriptionType.value) && !hasBillingCycles(type)) {
      setSelectedCycle(undefined);
    }
  };

  const onSaveClicked = async (e) => {
    e.preventDefault();

    if (isSaving) {
      return;
    }
    setIsSaving(true);

    try {
      await window.CoreApi.Client.SetClientNextSubscription({
        clientId: props.client.clientId,
        nextSubscriptionType: selectedType.value,
        nextBillingCycle: selectedCycle != null ? selectedCycle.value : undefined
      });

      window.location.reload();
    } catch (ex) {
      alert("Something went wrong...: " + ex);
      setIsSaving(false);
    }
  };

  const canBeSaved = hasBillingCycles(selectedType.value) ? selectedCycle != null : true;

  return <Modal
    width="small"
    title={`Next on ${formatLongDate(props.activeSubscription.end)} should be:`}
    handleClose={props.onClose}
    isOpen={props.isOpen}>
    <div className="margin-bottom-larger">
      <RadioGroup
        orientation="vertical"
        options={subscriptionTypeValues.map(type => {
          const subscriptionType = findEnumObject(type, serverReference.subscriptionTypes);
          return ({
            value: type,
            label: <Tag
              label={subscriptionType.internalText}
              size={"larger"}
              color={subscriptionType.hexColor} />,
            renderOnSelect: () => <TypeOption
              hasBillingCycle={hasBillingCycles(type)}
              type={type}
              selectedType={selectedType}
              selectedBillingCycle={selectedCycle}
              onBillingCycleChanged={setSelectedCycle}
            />
          });
        })}
        value={selectedType.value}
        onChange={onSubscriptionTypeChanged}
      />
    </div>
    <div className="flex justify-end">
      <div><Button disabled={!canBeSaved} primary loading={isSaving} onClick={onSaveClicked}>{RESX.Buttons.BtnOk}</Button></div>
    </div>
  </Modal>;
};

export default ChangeNextSubscriptionModal;